import { render, staticRenderFns } from "./BulkInsertUpdateStart.vue?vue&type=template&id=2e2616a7&scoped=true&"
import script from "./BulkInsertUpdateStart.vue?vue&type=script&lang=js&"
export * from "./BulkInsertUpdateStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2616a7",
  null
  
)

export default component.exports